import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Joyride from 'react-joyride';
import styled from "styled-components";
import TourToGuide from './Tour/TourToGuide'
import Spinner from "./dev/LoadingSpinner";
import Search from "./InfoList/Search";
import ChannelList from "./InfoList/ChannelList";
import VideoList from "./InfoList/VideoList";
import Sort from "./InfoList/Sort";
import Pagination from "./InfoList/Pagination";
import InfoListProposal from "./InfoList/InfoListProposal";
import PaymentBanner from './Payment/PaymentBanner';
import EmptyNotice from "./InfoList/EmptyNotice";
import axios from "axios";
import withLoginCheck from "./HOC/withLoginCheck";
import withTourCheck from './HOC/withTourCheck'
import {TourFakeChannelList, TourFakeSelectedCreators, TourFakeVideolList} from './InfoList/TourFakeData'

const { REACT_APP_URI = "/" } = process.env;
class InfoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoUrl: `${REACT_APP_URI}/Video/`,
            // isChannelTags: true,
            page: "",
            currentPage: 1,
            isChannelTags: true,
            isLoading: true,
            isEmpty: false,
            channel: {
                channelUrl: `${REACT_APP_URI}/Info/`,
                channelList: [],
                total: 0,
                pageCount: 0
            },
            video: {
                videoUrl: `${REACT_APP_URI}/Video/`,
                videoList: [],
                total2: 0,
                pageCount2: 0
            },
            channelSortCategory: "",
            channelSortRule: "",
            videoSortCategory: "",
            videoSortRule: "",
            selectedCreators: [],
            myProposals: [],
            exsitedCreators: [],
            proposalTitle: { id: "", title: "" },
            propoaslTitleList: [],
            infoListProposalResponse: "",
        };
    }
    componentDidMount() {
        this.getInfoList();
        this.getAllpropoasl();
    }
    componentDidUpdate() {
        const { isChannelTags } = this.state;
        const {
            url: {
                channelUrl,
                videoUrl,
                page,
                channelSortCategory,
                channelSortRule,
                videoSortCategory,
                videoSortRule
            }
        } = this.props;
        if(this.props.tour.isInfoListTourActive) return
        if (channelUrl !== "" || videoUrl !== "" || page !== "") {
            if (
                isChannelTags &&
                (channelUrl !== this.state.channel.channelUrl ||
                    page !== this.state.page ||
                    channelSortCategory !== this.state.channelSortCategory ||
                    channelSortRule !== this.state.channelSortRule)
            ) {
                this.setState({
                    channel: { ...this.state.channel, channelUrl: channelUrl },
                    page: page,
                    channelSortCategory: channelSortCategory,
                    channelSortRule: channelSortRule
                });
                this.getInfoList();
            }
            if (
                !isChannelTags &&
                (videoUrl !== this.state.video.videoUrl ||
                    page !== this.state.page ||
                    videoSortCategory !== this.state.videoSortCategory ||
                    videoSortRule !== this.state.videoSortRule)
            ) {
                this.setState({
                    video: { ...this.state.video, videoUrl: videoUrl },
                    page: page,
                    videoSortCategory: videoSortCategory,
                    videoSortRule: videoSortRule
                });
                this.getInfoList();
            }
        }
    }
    //導覽功能 function //
    handleJoyrideCallback = (data) => {
        const { toggleTags } = this
        const { action, index, step: {target} } = data;
        const finishedStatuses = ["close", "reset"]
        const element = document.querySelector(target);
        //spotlight置中
        if(element) {
            element.scrollIntoView({
                block: 'center' 
            });
            let spotlight = document.querySelector(".react-joyride__spotlight")
            if(spotlight && spotlight.style.position !== 'fixed'){
                const realPosition = `${spotlight.offsetTop + window.scrollY}px`
                spotlight.style.top = realPosition
            }
        }
        //結束教學
        if(finishedStatuses.includes(action)) {
            this.props.dispatch({ type: `setInfoListTour`, [`isInfoListTourActive`]: false })
        }
        //第五步(index4)切換tags
        if(index < 4) toggleTags(true) 
        else toggleTags(false)
    }
    tourToPayment = () => {
        const { user: {auth}} = this.props
        this.props.dispatch({ type: `setInfoListTour`, [`isInfoListTourActive`]: false })
        if(auth === "notSignIn") {
            this.props.dispatch({ type: 'toggleUserField', condition: 'signIn'})
        }
        else {
            this.props.dispatch({ 
                type: 'togglePaymentField', 
                isPaymentGuideActive: true,
                paymentGuideMinPlan: "Agency",
            })
        }
    }
    ////導覽功能 function end//
    makeCancelableRequest = () => {
        let call;
        return url => {
            if (call) {
                call.cancel("cancel previous request");
            }
            call = axios.CancelToken.source();
            return axios.get(url, {
                withCredentials: true,
                cancelToken: call.token
            });
        };
    };
    get = this.makeCancelableRequest();
    getInfoList = async () => {
        const {
            url: {
                channelUrl,
                videoUrl,
                page,
                channelSortCategory,
                channelSortRule,
                videoSortCategory,
                videoSortRule
            }
        } = this.props;
        const { isChannelTags } = this.state;
        const { get } = this;
        this.setState({ isEmpty: false });
        try {
            this.setState({ isLoading: true });
            if (isChannelTags) {
                await get(
                    `${channelUrl}&${page}&sortCategory=${channelSortCategory}&sortRule=${channelSortRule}`
                )
                    .then(res => {
                        const { status } = res;
                        if (status === 200) {
                            return res.data;
                        }
                        throw this.setState({ isLoading: false });
                    })
                    .then(({ channelList, total, pageCount }, status) => {
                        channelList = channelList.map(i => {
                            return { ...i, isCheck: false };
                        });
                        this.setState({
                            channel: {
                                ...this.state.channel,
                                channelList,
                                total,
                                pageCount
                            },
                            isLoading: false
                        });
                        if (channelList.length === 0)
                            this.setState({ isEmpty: true });
                        if (status === 603) {
                            this.props.dispatch({
                                type: "setAuth",
                                auth: "notSignIn"
                            });
                            this.setState({ isEmpty: true, isLoading: false });
                        }
                    });
            } else {
                fetch(
                    `${videoUrl}&${page}&sortCategory=${videoSortCategory}&sortRule=${videoSortRule}`,
                    { credentials: "include" }
                )
                    .then(res => {
                        const { status } = res;
                        if (status === 200) {
                            return res.json();
                        }
                        throw this.setState({ isLoading: false });
                    })
                    .then(({ videoList, total, pageCount }, status) => {
                        videoList = videoList.map(i => {
                            return { ...i, isCheck: false };
                        });
                        this.setState({
                            video: {
                                ...this.state.video,
                                videoList,
                                total2: total,
                                pageCount2: pageCount
                            },
                            isLoading: false
                        });
                        if (
                            videoList.length === 0 &&
                            videoUrl !==
                                `${REACT_APP_URI}/Video/?keyword=&country=&category=&subscriberCountFrom=1000&subscriberCountTo=2000000&viewCountFrom=5000&viewCountTo=2000000&engageRateFrom=0&engageRateTo=7`
                        )
                            this.setState({ isEmpty: true });
                        if (status === 603 || status === 604)
                            this.setState({ isLoading: false, isEmpty: true });
                        if (status === 603)
                            this.props.dispatch({
                                type: "setAuth",
                                auth: "notSignIn"
                            });
                    });
            }
        } catch (err) {
            if (
                err.response !== undefined &&
                (err.response.status === 603 || err.response.status === 604)
            ) {
                this.setState({ isLoading: false });
            }
            if (axios.isCancel(err)) {
                console.error(`Cancelling previous request: ${err.message}`);
            }
        }
    };
    selectCreator = id => {
        let {
            channel: { channelList },
            selectedCreators,
            exsitedCreators
        } = this.state;
        const isCreatorExsit =
            selectedCreators.concat(exsitedCreators).find(i => i.id === id) !==
            undefined;
        const selectedCreator = channelList.filter(i => i.id === id);
        if (isCreatorExsit) {
            const nextExsitedCreators = exsitedCreators.filter(
                i => i.id !== id
            );
            const nextSelectedCreators = selectedCreators.filter(
                i => i.id !== id
            );
            this.setState({
                selectedCreators: nextSelectedCreators,
                exsitedCreators: nextExsitedCreators,
                infoListProposalResponse: this.props.messages
                    .info_list_panel_unsave
            });
        } else {
            this.setState({
                selectedCreators: [...selectedCreator, ...selectedCreators],
                infoListProposalResponse: this.props.messages
                    .info_list_panel_unsave
            });
        }
    };
    toggleTags = value => this.setState({ isChannelTags: value });
    togglePage = page => {
        this.setState({ currentPage: parseInt(page, 10) }, () => {
            this.props.dispatch({ type: "CHANGE_PAGE", page: parseInt(page, 10) - 1 });
            window.scrollTo(0, 0);
        });
    };
    setCurrentPage = currentPage => {
        this.setState({ currentPage });
    };
    getAllpropoasl = () => {
        fetch(`${REACT_APP_URI}/getMyProposals/`, { credentials: "include" })
            .then(res => {
                if (res.ok) return res.json();
                throw res;
            })
            .then(({ mine }) => {
                const propoaslTitleList = mine.map(({ id, title }) => {
                    return { value: id, label: title, clearableValue: false };
                });
                this.setState({
                    myProposals: mine,
                    propoaslTitleList: propoaslTitleList
                });
            });
    };
    selectProposal = ({ value = "", label = "" }) =>
        this.setState(
            {
                proposalTitle: { id: value, title: label },
                infoListProposalResponse: this.props.messages
                    .info_list_panel_unsave
            },
            () => this.setExistedCreators()
        );
    setExistedCreators = () => {
        const {
            proposalTitle: { id },
            myProposals
        } = this.state;
        const exsitedCreators = myProposals.filter(
            proposal => proposal.id === id
        )[0].channels;
        this.setState({ exsitedCreators });
    };
    deleteExsitedCreator = id => {
        const { exsitedCreators, selectedCreators } = this.state;
        const nextExsitedCreators = exsitedCreators.filter(i => i.id !== id);
        const nextSelectedCreators = selectedCreators.filter(i => i.id !== id);
        this.setState({
            selectedCreators: nextSelectedCreators,
            exsitedCreators: nextExsitedCreators,
            infoListProposalResponse: this.props.messages.info_list_panel_unsave
        });
    };
    proposalSubmit = (id = "") => {
        const {
            messages,
            user: { token, plan }
        } = this.props;
        if (plan !== "Agency") {
            this.setState({ infoListProposalResponse: "brandCondition" });
        } else {
            if (id === "")
                this.setState({
                    infoListProposalResponse:
                        messages.info_list_panel_no_proposal
                });
            else {
                const { selectedCreators, exsitedCreators } = this.state;
                const mix = selectedCreators
                    .concat(exsitedCreators)
                    .map(i => i.id);
                fetch(`${REACT_APP_URI}/api/Proposal/${id}/`, {
                    method: "put",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-CSRFToken": token
                    },
                    body: JSON.stringify({
                        channels: mix
                    })
                }).then(res => {
                    if (res.status === 200)
                        this.setState(
                            {
                                infoListProposalResponse:
                                    messages.info_list_panel_all_saved
                            },
                            () => this.getAllpropoasl()
                        );
                    else
                        this.setState({
                            infoListProposalResponse:
                                messages.payment_unknown_error
                        });
                });
            }
        }
    };
    resetAllcreators = () =>
        this.setState({ exsitedCreators: [], selectedCreators: [] });
    render() {
        const { plan, auth } = this.props.user;
        const {
            channel: { channelList, total, pageCount },
            video: { videoList, total2, pageCount2 },
            isChannelTags,
            currentPage,
            isLoading,
            isEmpty,
            selectedCreators,
            myProposals,
            exsitedCreators,
            proposalTitle,
            propoaslTitleList,
            infoListProposalResponse,
        } = this.state;
        const {
            toggleTags,
            togglePage,
            setCurrentPage,
            selectCreator,
            resetAllcreators,
            selectProposal,
            proposalSubmit,
            deleteExsitedCreator,
            handleJoyrideCallback,
        } = this;
        const { messages, tour:{ isInfoListTourActive} } = this.props;
        return (
            <Container id="Infolist">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    run={isInfoListTourActive}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={[
                        { 
                            target: '#user_tour_infolist_1',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_1}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_infolist_1_content,
                            hideCloseButton: true,
                            disableBeacon: true,
                            spotlightClicks: true,
                        },
                        {
                            target: '#user_tour_infolist_2',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_2}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_infolist_2_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_infolist_3',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_3}
                                    tourContentPlan="Agency"
                                />),
                            content: messages.user_tour_infolist_3_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_infolist_4',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_4}
                                    tourContentPlan="Agency"
                                />),
                            content: messages.user_tour_infolist_4_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_infolist_5',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_5}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_infolist_5_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_infolist_6',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_6}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_infolist_6_content,
                            hideCloseButton: true,
                        },
                        {
                            target: '#user_tour_infolist_7',
                            title: (
                                <TourToGuide
                                    title={messages.user_tour_infolist_7}
                                    tourContentPlan="Brand"
                                />),
                            content: messages.user_tour_infolist_7_content,
                            hideCloseButton: true,
                        },
                    ]}
                    styles={{
                        options: {
                        //   backgroundColor: '#e94242',
                        //   overlayColor: 'rgba(0, 0, 0, 0.4)',
                          primaryColor: '#e94242',
                          textColor: '#666',
                        //   width: 900,
                          zIndex: 30001,
                        },
                        tooltipTitle: {
                            color: '#666',
                        }
                      }}
                    
                    locale={{
                        back: messages.user_tour_previous, 
                        next: messages.user_tour_next, 
                        close: 'Close', 
                        last: messages.user_tour_finish, 
                        skip: messages.user_tour_finish }}
                />
                <Search
                    isChannelTags={isChannelTags}
                    toggleTags={toggleTags}
                    setCurrentPage={setCurrentPage}
                />
                {/* <div id="user_tour_infolist_1">123</div> */}
                <Sort
                    length={
                        isChannelTags ? channelList.length : videoList.length
                    }
                    total={isChannelTags ? total : total2}
                    isChannelTags={isChannelTags}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {isLoading && <Spinner />}
                {!isLoading && isChannelTags && (
                    <ChannelList
                        channelList={isInfoListTourActive ? TourFakeChannelList : channelList}
                        selectedCreators={isInfoListTourActive ? TourFakeSelectedCreators : selectedCreators}
                        exsitedCreators={exsitedCreators}
                        selectCreator={selectCreator}
                        plan={plan}
                        auth={auth}
                        isInfoListTourActive={isInfoListTourActive}
                    />
                )}
                {!isLoading && !isChannelTags && (
                    <VideoList
                        videoList={isInfoListTourActive ? TourFakeVideolList : videoList}
                        selectCreator={selectCreator}
                        isInfoListTourActive={isInfoListTourActive}
                    />
                )}
                {!isLoading && isEmpty && (
                    <EmptyNotice isChannelTags={isChannelTags} />
                )}
                {!isLoading && isChannelTags && !isEmpty && (
                    <Pagination
                        pageCount={pageCount}
                        currentPage={currentPage}
                        togglePage={togglePage}
                        messages={messages}
                    />
                )}
                {!isLoading && !isChannelTags && videoList.length !== 0 && (
                    <Pagination
                        pageCount={pageCount2}
                        currentPage={currentPage}
                        togglePage={togglePage}
                        messages={messages}
                    />
                )}
                <InfoListProposal
                    selectedCreators={isInfoListTourActive ? TourFakeSelectedCreators : selectedCreators}
                    infoListProposalResponse={infoListProposalResponse}
                    selectCreator={selectCreator}
                    resetAllcreators={resetAllcreators}
                    selectProposal={selectProposal}
                    proposalSubmit={proposalSubmit}
                    deleteExsitedCreator={deleteExsitedCreator}
                    myProposals={myProposals}
                    exsitedCreators={exsitedCreators}
                    proposalTitle={proposalTitle}
                    propoaslTitleList={propoaslTitleList}
                    isInfoListTourActive={isInfoListTourActive}
                />
                <PaymentBanner bannerPlan={"Brand"}/>
            </Container>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        payment: state.Payment,
        url: state.InfoList,
        messages: state.Messages,
        tour: state.Tour
    };
};
export default withRouter(connect(mapStateToProps)(withLoginCheck(withTourCheck(InfoList))));
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    overflow: scroll;
    @media (max-width: 900px) {
        align-items: initial;
    }
`;
const UnlockButton = styled.div`
    display: flex;
    justify-content: center;
    min-width: 80px;
    padding: 0 8px;
    color: #e94242;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: 0.8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    margin-top: 6px;
    cursor: pointer;
`;


// WEBPACK FOOTER //
// ./src/InfoList.js